import {useTileAnimation, type TileProps} from './types'

export const Tile6 = ({className, colors, delay}: TileProps) => {
  const svgRef = useTileAnimation({
    delay,
    selector: 'g rect',
    scaleProperty: 'scaleX',
    transformOrigin: '0% 50%',
  })

  return (
    <svg
      ref={svgRef}
      className={className}
      width="400"
      height="146"
      viewBox="0 0 400 146"
      fill="none"
      aria-hidden="true"
    >
      <g clipPath="url(#page-divider-tile-6-clip)">
        <rect width="400" height="240" transform="translate(0 -7.55859)" fill={colors[0]} />
        <rect x="-86" y="112.441" width="160" height="40" fill={colors[1]} />
        <rect x="-6" y="72.4414" width="160" height="40" fill={colors[1]} />
        <rect x="74" y="32.4414" width="160" height="40" fill={colors[1]} />
        <rect x="154" y="-7.55859" width="160" height="40" fill={colors[1]} />
        <rect x="234" y="112.441" width="268" height="40" fill={colors[1]} />
        <rect x="314" y="80.4414" width="160" height="40" fill={colors[1]} />
      </g>
      <defs>
        <clipPath id="page-divider-tile-6-clip">
          <rect width="400" height="240" fill="white" transform="translate(0 -7.55859)" />
        </clipPath>
      </defs>
    </svg>
  )
}
